import React from "react";
import "./ConfigurePayout.css";
import Sidebar from "../../Navigation/Sidebar/Sidebar";
import leftArrow from "../../../assests/leftArrow.svg";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Button from "@mui/material/Button";
import CohortCreateComponent from "./CohortCreate/component";
import CreateFranchiesComponent from "./CreateFranchies/component";
import MapToChargeComponent from "./MapToCharge/component";
import BankDetailsComponent from "./BankDetails/component";
import { useNavigate } from "react-router-dom";

const ConfigurepayoutComponent = (props) => {
  const steps = [
    "Create Cohort",
    "Create Franchise",
    "Map Charges",
    "Bank Details",
  ];

  const navigate = useNavigate();

  const handleBackClick = () => {
    navigate("/home/configuration/managepartners");
  };

  const handleSaveClick = async () => {
    if (props.activeStep === steps.length - 0) {
      props.handleBankDetails();
    } else {
      props.handleNext();
    }
  };

  return (
    <div className="fs-main-container">
      <Sidebar />
      
      <div className="fs-content-area">
        <div className="fs-header-section">
          <h2 className="fs-header-title">
            <img 
              onClick={handleBackClick}
              className="fs-back-arrow" 
              src={leftArrow} 
              alt="Back" 
            />
            Create Franchise
          </h2>
        </div>
        
        <div className="fs-stepper-container">
          <Box className="fs-stepper">
            <Stepper activeStep={props.activeStep} alternativeLabel>
              {steps.map((label) => (
                <Step key={label}>
                  <StepLabel>{label}</StepLabel>
                </Step>
              ))}
            </Stepper>
          </Box>
        </div>
        
        <div className="fs-form-content">
          {props.activeStep === 0 && (
            <CohortCreateComponent
              formData={props.formData}
              setFormData={props.setFormData}
              handleChangeCohort={props.handleChangeCohort}
              handleCreateCohort={props.handleCreateCohort}
            />
          )}
          
          {props.activeStep === 1 && (
            <CreateFranchiesComponent
              formDataFranchisee={props.formDataFranchisee}
              setFormDataFranchisee={props.setFormDataFranchisee}
              handleChangeFranchisee={props.handleChangeFranchisee}
              handleCreateFranchisee={props.handleCreateFranchisee}
              warehouseList= {props.warehouseList}
              cohortId={props.cohortId}
              errors={props.errors}
            />
          )}
          
          {props.activeStep === 2 && (
            <MapToChargeComponent
              createFranchiseeCharges={props.createFranchiseeCharges}
              selectedChargeIds={props.selectedChargeIds}
              handleCheckboxChange={props.handleCheckboxChange}
            />
          )}
          
          {props.activeStep === 3 && (
            <BankDetailsComponent
              handleChangeBankDetails={props.handleChangeBankDetails}
              formDataBank={props.formDataBank}
              handleBankDetails={props.handleBankDetails}
              franchiseeId={props.franchiseeId}
              handleSaveButtonClick={props.handleSaveButtonClick}
            />
          )}
        </div>
        
        <div className="fs-action-buttons">
          <Button
            className="fs-nav-button"
            variant="outlined"
            disabled={props.activeStep === 0}
            onClick={props.handleClose}
            size="medium"
          >
            Back
          </Button>
          
          {props.activeStep === steps.length - 0 ? (
            <Button 
              className="fs-nav-button"
              variant="contained" 
              color="primary"
              onClick={handleSaveClick}
              size="medium"
            >
              Save
            </Button>
          ) : (
            <Button 
              className="fs-nav-button"
              variant="contained" 
              color="primary"
              onClick={props.handleNext}
              size="medium"
            >
              Continue
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ConfigurepayoutComponent;